import * as Config from '../../../../../../config';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import GridFull from '../../../../content/grid/GridFull';
import CardLoading from '../../../../common/CardLoading';
import FilterSelect from '../../../../common/FilterSelect';
import CardAction from './CardAction';

import useRaw from '../../../../../../hooks/useRaw';

const customFilters = [`Recent`, `A-Z`, `Z-A` /*, `0-9`, `A`, `B`, `C`, `D`, `E`, `F`, `G`, `H`, `I`, `J`, `K`, `L`, `M`, `N`, `O`, `P`, `Q`, `R`, `S`, `T`, `U`, `V`, `W`, `X`, `Y`, `Z`*/];
function GridCardActions(props) {
  const { id, pathApi, perPage, type, placeholder } = props;
  const [filter, setCurrentFilter] = useState(`Recent`);
  const [dataHook] = useRaw(id, pathApi, perPage, type);
  const selectFilter = (index) => { setCurrentFilter(customFilters[index]) }

  let dataFiltered = (dataHook) ? { ...dataHook } : null;
  if (dataFiltered) { // API - No Filter `Order by` available
    if (filter === `Recent`) { dataFiltered.items = dataHook.itemsFull.filter( x => true ) }
    else if (filter === `A-Z`) { dataFiltered.items = dataHook.itemsFull.filter( x => true ).sort(Config.sortAlpha(`forOrder`, true)); }
    else if (filter === `Z-A`) { dataFiltered.items = dataHook.itemsFull.filter( x => true ).sort(Config.sortAlpha(`forOrder`, false)); }
    else if (filter === `0-9`) { dataFiltered.items = dataHook.itemsFull.filter( x => x.name[0].toLowerCase().charCodeAt() < 97 ||  x.name[0].toLowerCase().charCodeAt() > 122  ).sort(Config.sortAlpha(`forOrder`, true)); }
    else { dataFiltered.items = dataHook.itemsFull.filter( x => x.name[0].toLowerCase() === filter.toLowerCase() ).sort(Config.sortAlpha(`forOrder`, true)); }
  }

  return (dataFiltered && dataHook.itemsFull.length > 0 ) ? (
    <>
      <FilterSelect values={customFilters} width={60} height={75} selected={filter}
        onSelected={selectFilter} style={{position: `absolute`, right: 0, top: 16, zIndex: 100}}
      />
      <GridFull
        {...props}
        gutter={{ top: 4, left: 4, width: 4, gap: 30 }}
        dataHook={dataFiltered}
        element={<CardAction className={`card-action`} isOnlyCover={true} />}
        loadingElement={ <CardLoading isOnlyCover={true} /> }
      />
    </>
  ) : ( (dataFiltered && dataHook.itemsFull.length === 0) 
    ? <span className={'type-placeholder'} style={{marginTop: 16, position: 'absolute'}}>{placeholder}</span>
    : null 
  )
}

GridCardActions.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.any,
  height: PropTypes.number.isRequired,
  title: PropTypes.string,
  pathApi: PropTypes.string.isRequired,
  hasFilters: PropTypes.bool,
  filtersStyle: PropTypes.object,
  forceHeight: PropTypes.number,
  rowCount: PropTypes.number,
  rowHeight: PropTypes.number,
  columnCount: PropTypes.number,
  hasPagination: PropTypes.bool,
  perPage: PropTypes.number,
  allTo: PropTypes.any,
  style: PropTypes.object,
  type: PropTypes.string.isRequired,
}

export default GridCardActions;
